"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeList = void 0;
const dht_1 = require("@streamr/dht");
const sample_1 = __importDefault(require("lodash/sample"));
const eventemitter3_1 = require("eventemitter3");
const getValuesOfIncludedKeys = (nodes, exclude, wsOnly = false) => {
    const values = wsOnly
        ? Array.from(nodes.entries()).filter(([_, node]) => node.getPeerDescriptor().websocket !== undefined)
        : Array.from(nodes.entries());
    return values
        .filter(([id]) => !exclude.includes(id))
        .map(([_id, node]) => node);
};
// The items in the list are in the insertion order
class NodeList extends eventemitter3_1.EventEmitter {
    nodes;
    limit;
    ownId;
    constructor(ownId, limit) {
        super();
        this.nodes = new Map();
        this.limit = limit;
        this.ownId = ownId;
    }
    add(remote) {
        const nodeId = (0, dht_1.toNodeId)(remote.getPeerDescriptor());
        if ((this.ownId !== nodeId) && (this.nodes.size < this.limit)) {
            const isExistingNode = this.nodes.has(nodeId);
            this.nodes.set(nodeId, remote);
            if (!isExistingNode) {
                this.emit('nodeAdded', nodeId, remote);
            }
        }
    }
    remove(nodeId) {
        if (this.nodes.has(nodeId)) {
            const remote = this.nodes.get(nodeId);
            this.nodes.delete(nodeId);
            this.emit('nodeRemoved', nodeId, remote);
        }
    }
    has(nodeId) {
        return this.nodes.has(nodeId);
    }
    // Replace nodes does not emit nodeRemoved events, use with caution
    replaceAll(neighbors) {
        this.nodes.clear();
        const limited = neighbors.splice(0, this.limit);
        limited.forEach((remote) => {
            this.add(remote);
        });
    }
    getIds() {
        return Array.from(this.nodes.keys());
    }
    get(id) {
        return this.nodes.get(id);
    }
    size(exclude = []) {
        return Array.from(this.nodes.keys()).filter((node) => !exclude.includes(node)).length;
    }
    getRandom(exclude) {
        return (0, sample_1.default)(getValuesOfIncludedKeys(this.nodes, exclude));
    }
    getFirst(exclude, wsOnly = false) {
        const included = getValuesOfIncludedKeys(this.nodes, exclude, wsOnly);
        return included[0];
    }
    getFirstAndLast(exclude) {
        const included = getValuesOfIncludedKeys(this.nodes, exclude);
        if (included.length === 0) {
            return [];
        }
        return included.length > 1 ? [this.getFirst(exclude), this.getLast(exclude)] : [this.getFirst(exclude)];
    }
    getLast(exclude) {
        const included = getValuesOfIncludedKeys(this.nodes, exclude);
        return included[included.length - 1];
    }
    getAll() {
        return Array.from(this.nodes.values());
    }
    stop() {
        this.nodes.forEach((node) => this.remove((0, dht_1.toNodeId)(node.getPeerDescriptor())));
        this.removeAllListeners();
    }
}
exports.NodeList = NodeList;
//# sourceMappingURL=NodeList.js.map